{
  "name": "damoauth",
  "version": "1.4.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --poll=1000",
    "start:local": "ng serve --poll=1000 --configuration=local",
    "build": "ng build damoauth --configuration=production",
    "build-dev": "ng build damoauth --configuration=development",
    "build-staging": "ng build damoauth --configuration=staging",
    "build-prod": "ng build damoauth --configuration=production",
    "build-dev:watch": "ng build damoauth --configuration=development --watch",
    "build-lib-dev": "ng build damoauth-lib --configuration=development",
    "build-lib-prod": "ng build damoauth-lib --configuration=production",
    "build-lib-staging": "ng build damoauth-lib --configuration=staging",
    "package-dev": "npm run build-lib-dev && npm run publish-dev",
    "package-staging": "npm run build-lib-staging && npm run publish-staging",
    "package-prod": "npm run build-lib-prod && npm run publish-prod",
    "publish-dev": "cd dist/damoauth-lib && V=$(jq -r '.version' ../../package.json) && jq --arg v \"$V-dev\" '.version = $v' package.json > /tmp/pkg.json && mv /tmp/pkg.json package.json && npm publish --tag dev -f",
    "publish-staging": "cd dist/damoauth-lib && V=$(jq -r '.version' ../../package.json) && jq --arg v \"$V-staging\" '.version = $v' package.json > /tmp/pkg.json && mv /tmp/pkg.json package.json && npm publish --tag staging -f",
    "publish-prod": "cd dist/damoauth-lib && V=$(jq -r '.version' ../../package.json) && jq --arg v \"$V-prod\" '.version = $v' package.json > /tmp/pkg.json && mv /tmp/pkg.json package.json && npm publish --tag prod -f",
    "watch": "ng build damoauth --watch --configuration development",
    "deploy": "firebase deploy --only hosting:damoauth --debug",
    "test-lib": "ng test damoauth-lib",
    "test-lib:coverage": "ng test damoauth-lib --code-coverage",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui"
  },
  "dependencies": {
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.19",
    "@angular/animations": "^20.3.19",
    "@angular/build": "^20.3.24",
    "@angular/cdk": "^20.2.14",
    "@angular/cli": "^20.3.19",
    "@angular/common": "^20.3.19",
    "@angular/compiler": "^20.3.19",
    "@angular/compiler-cli": "^20.3.19",
    "@angular/core": "^20.3.19",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.19",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.19",
    "@angular/platform-browser-dynamic": "^20.3.19",
    "@angular/router": "^20.3.19",
    "@ngx-translate/core": "^17.0.0",
    "@playwright/test": "^1.61.1",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/exec": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@sentry/angular": "^10.55.0",
    "@tanstack/angular-form": "^0.42.0",
    "@types/jasmine": "^6.0.0",
    "@types/node": "^20.14.8",
    "firebase": "^11",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "nanostores": "^0.11.3",
    "ng-packagr": "^20.3.2",
    "postcss": "^8.5.2",
    "prettier": "^3.0.0",
    "rxjs": "~7.8.0",
    "semantic-release": "^24.0.0",
    "typescript": "~5.9.3",
    "zone.js": "~0.15.0"
  },
  "peerDependencies": {
    "@angular/animations": "^20.3.19",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.19",
    "@angular/core": "^20.3.19",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.19",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.19",
    "@angular/router": "^20.3.19",
    "@ngx-translate/core": "^17.0.0",
    "firebase": "^11",
    "rxjs": "~7.8.0",
    "zone.js": "~0.15.0"
  }
}
